$("html[lang=en] variant-selects .form__label").each(function() {
 if ($(this).text() == 'Color') { $(this).text('Colour'); }
 if ($(this).text() == 'Tamaño') { $(this).text('Size'); }
});
$("html[lang=fr] variant-selects .form__label").each(function() {
 if ($(this).text() == 'Color') { $(this).text('Coleur'); }
 if ($(this).text() == 'Tamaño') { $(this).text('Taille'); }
});

$("html[lang=en] .cart-item .product-option dt").each(function() {
 if ($(this).text() == 'Color:') { $(this).text('Colour:'); }
 if ($(this).text() == 'Tamaño:') { $(this).text('Size:'); }
});
$("html[lang=fr] .cart-item .product-option dt").each(function() {
 if ($(this).text() == 'Color:') { $(this).text('Coleur:'); }
 if ($(this).text() == 'Tamaño:') { $(this).text('Taille:'); }
});